<template>
  <div class="navbar fixed-top bg-white shadow-lg">
    <nav class="container d-flex">
      <div class="d-flex align-items-center">
        <img
          src="../assets/logo.jpg"
          alt="reading-list logo"
          class="rounded-circle nav-logo"
        />
        <h1 class="text-warning mb-0 ms-1 fs-4">My Book List</h1>
      </div>

      <!-- logged in users -->

      <div
        v-if="user"
        class="d-flex justify-content-between align-items-center"
      >
        <router-link to="/" class="text-warning me-3 text-decoration-none"
          >Home</router-link
        >

        <!-- show user name -->
        <p v-if="user" class="mb-0">Welcome {{ user.email }}</p>

        <button @click="handleClick" class="btn me-1">Logout</button>

        <router-link to="/addbook" class="btn btn-warning"
          >Add New Book</router-link
        >
      </div>

      <!-- logged out users -->
      <div v-if="!user">
        <router-link to="/login" class="btn btn-warning">Login</router-link>
        <router-link to="/signup" class="text-warning ms-3 text-decoration-none"
          >Signup</router-link
        >
      </div>
    </nav>
  </div>
</template>

<script>
import getUser from "../composables/getUser";
import { useRouter } from "vue-router";
import { watchEffect } from "vue";

// firebase imports
import { auth } from "../firebase/config";
import { signOut } from "firebase/auth";
export default {
  setup() {
    const { user } = getUser();
    const router = useRouter();
    const handleClick = () => {
      signOut(auth);
    };
    watchEffect(() => {
      if (
        (!user.value && router.currentRoute.value.name == "Home") ||
        (!user.value && router.currentRoute.value.name == "CreateBookForm")
      ) {
        router.push("/login");
      }
    });
    return { handleClick, user };
  },
};
</script>

<style>
.nav-logo {
  width: 40px;
}
</style>
